// export const IS_ANALYTICS_4 = 'function' === typeof gtag
export const IS_MATOMO_DATA_LAYER = window && 'object' === typeof window._mtm
export const IS_GOOGLE_DATA_LAYER = 'object' === typeof dataLayer